export class BadRequestResponse {
    public static readonly status = 400;

    public static error(message: string, options?: ErrorOptions) {
        return new BadRequestResponse.Error(message, options);
    }

    public static Error = class BadRequest extends Error {
        constructor(message = '400 Bad Request', options?: ErrorOptions) {
            super(message, options);

            this.name = 'BadRequest';

            Object.setPrototypeOf(this, BadRequest.prototype);

            if (Error.captureStackTrace) {
                Error.captureStackTrace(this, BadRequest);
            }
        }
    };
}
